<template>
    <div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-else>
            <v-row>
                <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
                    <div class="title_page ma-3">
                        <h4 class="breadcrumb_title_page">เพิ่มสินค้าเข้าคลัง</h4>
                        <v-breadcrumbs :items="sub_menu">
                            <template v-slot:divider>
                                <v-icon>mdi-chevron-right</v-icon>
                            </template>
                        </v-breadcrumbs>
                    </div>
                </v-col>
                <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
                    <div class="title_page ma-3">
                        <v-btn type="button" class="btn_back_page" elevation="4" @click="$router.back()"
                            large>ย้อนกลับ</v-btn>
                    </div>
                </v-col>
            </v-row>
            <v-card elevation="4" style="border-radius: 15px;">
                <v-card-text>
                    <div class="mt-3 pa-4">
                        <v-form ref="setting" @submit.prevent="saveProduct()">
                            <v-row>
                                <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="8">
                                    <div class="d-flex">
                                        <div class="title_form_main">
                                            <div class="logo_timeline">
                                                <img src="@/assets/arin_assets/ordericon.png">
                                            </div>
                                        </div>
                                        <div class="header-content py-1 pl-5 pr-5 text-center">
                                            <div class="content-font">ข้อมูลใบสั่งซื้อ</div>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="4">
                                    <div class="d-flex justify-end">
                                        <v-switch
                                            v-model="ref"
                                            @click="clearTotal(), receipt_no = null"
                                            color="#86bc3a"
                                            inset
                                        ></v-switch>
                                        <div class="mt-1∂" style="font-size:16px;">อ้างอิงเลขที่เอกสารในระบบ</div>
                                    </div>
                                </v-col>
                                <v-col v-if="this.ref === true" xs="12" sm="6" md="6" lg="3" xl="3" cols="6">
                                    <v-form-group>
                                        <label class="label_form_text">เลขที่ใบอ้างอิง/ No. <span
                                                class="required--text">*</span></label>
                                        <v-autocomplete color="#D6BFAF" class="input-radius" :items="order_list"
                                            @change="getOrderDetail()" prepend-inner-icon="mdi-file-document"
                                            item-text="order_code" v-model="order_id" item-value="id" hide-details="auto"
                                            placeholder="กรุณาเลือกเลขที่ใบอ้างอิง/ No." single-line outlined required
                                            :rules="[v => !!v || 'กรุณาเลือกข้อมูล']" dense></v-autocomplete>
                                    </v-form-group>
                                </v-col>
                                <v-col v-else xs="12" sm="6" md="6" lg="3" xl="3" cols="6">
                                    <v-form-group>
                                        <label class="label_form_text">เลขที่ใบอ้างอิง/ No. </label>
                                        <v-text-field type="text" class="input-radius" label="เลขที่ใบอ้างอิง/ No."
                                            v-model="reference_no" prepend-inner-icon="mdi-file-document" color="#D6BFAF"
                                            single-line outlined dense></v-text-field>
                                    </v-form-group>
                                </v-col>
                                <v-col v-if="this.ref === true" xs="12" sm="6" md="6" lg="3" xl="3" cols="6">
                                    <v-form-group>
                                        <label class="label_form_text">เลขที่ใบเสร็จ/ใบ CN <span
                                                class="required--text">*</span></label>
                                        <v-text-field color="#D6BFAF" class="input-radius" v-model="order.pr_code" :rules="[v => !!v || 'กรุณาเลือกข้อมูล']"
                                            prepend-inner-icon="mdi-file-document" hide-details="auto" single-line
                                            placeholder="เลขที่ใบเสร็จ/ใบ CN" value="vs014451" outlined dense 
                                            disabled required></v-text-field>
                                    </v-form-group>
                                </v-col>
                                <v-col v-else xs="12" sm="6" md="6" lg="3" xl="3" cols="6">
                                    <v-form-group>
                                        <label class="label_form_text">เลขที่ใบเสร็จ/ใบ CN <span
                                                class="required--text">*</span></label>
                                        <v-text-field v-if="receipt_no !=null" color="#D6BFAF" class="input-radius" v-model="receipt_no"
                                            prepend-inner-icon="mdi-file-document" hide-details="auto" single-line :rules="[v => !!v || 'กรุณาป้อนข้อมูล']"
                                            placeholder="เลขที่ใบเสร็จ/ใบ CN" outlined dense required></v-text-field>
                                        <v-text-field v-else color="#D6BFAF" class="input-radius" v-model="receipt_no"
                                            prepend-inner-icon="mdi-file-document" hide-details="auto" single-line @click="receipt_no = ''"
                                            placeholder="เลขที่ใบเสร็จ/ใบ CN" outlined dense ></v-text-field>
                                    </v-form-group>
                                </v-col>
                                <v-col v-if="this.ref === true" xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">ภาษีการซื้อ <span
                                                class="required--text">*</span></label>
                                        <v-radio-group row v-model="order.vat_type">
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="ภาษีรวมใน"
                                                color="#D6BFAF" :value="0" disabled></v-radio>
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="ภาษีแยกนอก"
                                                color="#D6BFAF" :value="1" disabled></v-radio>
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="ไม่มีภาษี"
                                                color="#D6BFAF" :value="2" disabled></v-radio>
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="ภาษีเป็น 0"
                                                color="#D6BFAF" :value="3" disabled></v-radio>
                                        </v-radio-group>
                                    </v-form-group>
                                </v-col>
                                <v-col v-else xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">ภาษีการซื้อ <span
                                                class="required--text">*</span></label>
                                        <v-radio-group row v-model="vat_type" @change="sumTotal()" required>
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="ภาษีรวมใน"
                                                color="#D6BFAF" :value="0" required></v-radio>
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="ภาษีแยกนอก"
                                                color="#D6BFAF" :value="1" required></v-radio>
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="ไม่มีภาษี"
                                                color="#D6BFAF" :value="2" required></v-radio>
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="ภาษีเป็น 0"
                                                color="#D6BFAF" :value="3" required></v-radio>
                                        </v-radio-group>
                                    </v-form-group>
                                </v-col>
                                <v-col v-if="this.ref === true" xs="12" sm="6" md="3" lg="3" xl="3" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">ชื่อ บริษัท/Supplier Name <span
                                                class="required--text">*</span></label>
                                        <p>บริษัท ฟาร์มาแคร์ พลัส จำกัด</p>
                                    </v-form-group>
                                </v-col>
                                <v-col v-else xs="12" sm="6" md="3" lg="3" xl="3" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">ชื่อ บริษัท/Supplier Name <span
                                                class="required--text">*</span></label>
                                        <v-autocomplete color="#D6BFAF" class="input-radius" :items="supplier_list"
                                            v-model="supplier_id" item-text="name" item-value="id" :rules="[v => !!v || 'กรุณาเลือกข้อมูล']"
                                            placeholder="ชื่อ บริษัท/Supplier Name" hide-details="auto" single-line outlined
                                            dense required></v-autocomplete>
                                    </v-form-group>
                                </v-col>
                                <v-col v-if="this.ref === true" xs="12" sm="6" md="3" lg="3" xl="3" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">วันที่ใบเสร็จ <span
                                                class="required--text">*</span></label>
                                        <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-calendar"
                                            hide-details="auto" single-line value="11/10/2022" outlined dense :rules="[v => !!v || 'กรุณาป้อนข้อมูล']"
                                            v-model="order.date" disabled required></v-text-field>
                                    </v-form-group>
                                </v-col>
                                <v-col v-else xs="12" sm="6" md="3" lg="3" xl="3" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">วันที่ใบเสร็จ <span
                                                class="required--text">*</span></label>
                                        <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false"
                                            transition="scale-transition" offset-y min-width="290px">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field class="input-radius" color="#D6BFAF" v-model="receipt_date"
                                                    label="" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" :rules="[v => !!v || 'กรุณาป้อนข้อมูล']"
                                                    v-on="on" outlined dense required></v-text-field>
                                            </template>
                                            <v-date-picker locale="TH" color="#D6BFAF" v-model="receipt_date"
                                                :min="receiptDateMin"
                                                no-title scrollable @input="menu_date = false"></v-date-picker>
                                        </v-menu>
                                    </v-form-group>
                                </v-col>
                                <v-col v-if="this.ref === true" xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">ประเภท <span class="required--text">*</span></label>
                                        <v-radio-group row v-model="is_credit" required>
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="เงินสด"
                                                color="#D6BFAF" :value="0" required></v-radio>
                                            <v-radio style="margin-top: 4px;padding-top: 4px;" label="เครดิต"
                                                color="#D6BFAF" :value="1" required></v-radio>
                                        </v-radio-group>
                                    </v-form-group>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <div class="d-flex">
                                        <div class="title_form_main">
                                            <div class="logo_timeline">
                                                <img src="@/assets/arin_assets/cycle.png">
                                            </div>
                                        </div>
                                        <div class="header-content py-1 pl-5 pr-5 text-center">
                                            <div class="content-font">รายการสินค้า</div>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col v-if="this.ref === false" xs="12" sm="6" md="9" lg="9" xl="9" cols="12">
                                    <v-form-group>
                                        <label class="label_form_text">สินค้า <span class="required--text">*</span></label>
                                        <v-autocomplete color="#D6BFAF" class="input-radius" :items="product_list"
                                            item-text="name" item-value="id" hide-details="auto" v-model="product_id"
                                            placeholder="กรุณาเลือกสินค้า" single-line outlined @change="getUnit_list()"
                                            :rules="[v => product.length > 0 || 'กรุณาเลือกข้อมูล']" dense></v-autocomplete>
                                    </v-form-group>
                                </v-col>
                                <v-col v-if="this.ref === false" xs="12" sm="6" md="3" lg="3" xl="3" cols="12">
                                    <label class="label_form_text">หน่วยนับ <span class="required--text">*</span></label>
                                    <v-autocomplete :key="'unit-' + (product_id || 'none')" class="input-radius" color="#D6BFAF" :items="unit_list"
                                        @change="addProduct()" :rules="[v => product.length > 0 || 'กรุณาเลือกข้อมูล']"
                                        item-text="unit_name" item-value="unit_id" v-model="unit_id"
                                        placeholder="กรุณาเลือกหน่วยนับ" hide-details="auto" single-line outlined dense />
                                </v-col>
                                <v-col v-if="this.ref === true" xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <v-simple-table fixed-header height="410px">
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-center">ลำดับ</th>
                                                    <th class="text-center">รหัสสินค้า</th>
                                                    <th>ล็อต</th>
                                                    <th>รายการสินค้า</th>
                                                    <th>หน่วยนับ</th>
                                                    <th class="text-center">จำนวนที่ได้รับ</th>
                                                    <th class="text-center">ราคาต่อหน่วย</th>
                                                    <th class="text-right">ราคารวม</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, i) in order_data" :key="item.id">
                                                    <td class="text-center hidden_line">{{ i + 1 }}</td>
                                                    <td class="text-center hidden_line">{{ item.product_code != null ?
                                                        item.product_code : '-' }}</td>
                                                    <td class="hidden_line">{{ item.lot_no }}</td>
                                                    <td class="hidden_line">
                                                        {{ item.product_name }}<br>วันที่หมดอายุ {{ item.date_expired }}
                                                    </td>

                                                    <td class="hidden_line">{{ item.unit_name }}</td>
                                                    <td class="text-center hidden_line">{{
                                                        parseFloat(item.quantity).toLocaleString()
                                                    }}</td>
                                                    <td class="text-center hidden_line">{{
                                                        parseFloat(item.price_per_unit).toLocaleString()
                                                    }}</td>
                                                    <td class="text-right hidden_line">{{
                                                        parseFloat(item.total).toLocaleString() }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <v-divider></v-divider>
                                </v-col>

                                <v-col v-else xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <v-simple-table fixed-header height="410px" @change="lastReceipt()">
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-center">ลำดับ</th>
                                                    <th>ล๊อต</th>
                                                    <th>รายการสินค้า</th>
                                                    <th>วันที่หมดอายุ</th>
                                                    <th class="text-center">หน่วยนับ</th>
                                                    <th class="text-center">จำนวนที่ได้รับ</th>
                                                    <th class="text-center">ราคาต่อหน่วย</th>
                                                    <th class="text-center">ส่วนลด (บาท)</th>
                                                    <th class="text-center">ส่วนลด (%)</th>
                                                    <th class="text-right">ราคารวม</th>
                                                    <th class="text-center">ลบ</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, i) in product" :key="item.id">
                                                    <td class="text-center hidden_line">{{ i + 1 }}</td>
                                                    <td class="hidden_line">
                                                        <v-text-field class="input-radius" type="text" min="0"
                                                            hide-details="auto" label="ล๊อต" v-model="item.lot_no" color="#D6BFAF"
                                                             placeholder="ล๊อต" @input="sumTotal(i)"
                                                            :rules="[v => !!v || 'กรุณากรอกข้อมูล']" single-line outlined
                                                            dense required></v-text-field>
                                                    </td>
                                                    <td class="hidden_line">{{ item.name }}</td>
                                                    <td class="hidden_line">
                                                        <v-menu ref="menu_date_exp" v-model="menu_date_exp[i]"
                                                            :close-on-content-click="false" transition="scale-transition"
                                                            offset-y min-width="auto">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-text-field class="input-radius" color="#D6BFAF"
                                                                    v-model="item.date_exp"
                                                                    prepend-inner-icon="mdi-calendar" readonly
                                                                    v-bind="attrs" v-on="on" single-line hide-details="auto"
                                                                    outlined dense></v-text-field>
                                                            </template>
                                                            <!-- @change="DateEXP_TH(item.dateEXP, i)" -->
                                                            <v-date-picker locale="TH" v-model="item.date_exp" :min="minDate" no-title scrollabl
                                                                dense></v-date-picker>

                                                                <!-- <v-date-picker locale="TH" color="#D6BFAF" v-model="receipt_date" :min="minDate"
                                                                no-title scrollabl></v-date-picker> -->
                                                        </v-menu>
                                                    </td>
                                                    <td class="text-center hidden_line">{{ item.unit }}</td>
                                                    <td class="text-center hidden_line">
                                                        <v-text-field class="input-radius" type="number" min="0"
                                                            hide-details="auto" label="จำนวนที่ได้รับ" v-model="item.qty" @input="sumTotal(i)"
                                                            color="#D6BFAF"
                                                            placeholder="จำนวนที่ได้รับ"
                                                            :rules="[v => !!v || 'กรุณากรอกข้อมูล']" single-line outlined
                                                            dense required></v-text-field>
                                                    </td>
                                                    <td class="text-center hidden_line">
                                                        <v-text-field class="input-radius" type="number" min="0"
                                                            hide-details="auto" label="ราคาต่อหน่วย" v-model="item.price"
                                                            @input="sumTotal(i)" color="#D6BFAF"
                                                            @keypress="isOnlyNumber($event)" placeholder="ราคาต่อหน่วย"
                                                            :rules="[v => !!v || 'กรุณากรอกข้อมูล']" single-line outlined
                                                            dense required></v-text-field>
                                                    </td>
                                                    <td class="text-center hidden_line">
                                                        <v-text-field class="input-radius" type="number" min="0"
                                                            hide-details="auto" label="ส่วนลด (บาท)" v-model="item.discount_amount"
                                                            @input="sumTotal(i)" color="#D6BFAF"
                                                            @keypress="isOnlyNumber($event)" placeholder="ส่วนลด (บาท)"
                                                            single-line outlined dense></v-text-field>
                                                    </td>
                                                    <td class="text-center hidden_line">
                                                        <v-text-field class="input-radius" type="number" min="0" max="100"
                                                            hide-details="auto" label="ส่วนลด (%)" v-model="item.discount_percent"
                                                            @input="sumTotal(i)" color="#D6BFAF"
                                                            @keypress="isOnlyNumber($event)" placeholder="ส่วนลด (%)"
                                                            single-line outlined dense></v-text-field>
                                                    </td>
                                                    <td class="text-right hidden_line">{{ formatPrice(item.total_price)
                                                    }}</td>
                                                    <td class="text-center hidden_line">
                                                        <v-btn elevation="4" class="ma-2" outlined color="error"
                                                            @click="deleteProduct(i)" title="ลบข้อมูล"
                                                            style="border-radius:10px">
                                                            <v-icon>mdi-trash-can-outline</v-icon>
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <v-divider></v-divider>
                                </v-col>
                                <v-row v-if="this.ref === true">
                                    <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12"></v-col>
                                    <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                                        <div class="d-flex" style="justify-content:space-between">
                                            <h3>รวม</h3>
                                            <h3>{{ formatPrice(total) }}</h3>
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-divider></v-divider>
                                    </v-col>
                                    <v-col xs="12" sm="12" md="9" lg="9" xl="9" cols="12"></v-col>
                                    <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
                                        <div class="d-flex" style="justify-content:space-between">
                                            <p style="font-size:16px;">ส่วนลดท้ายบิล</p>
                                            <p style="font-size:16px;">{{ formatPrice(discount) }}</p>
                                        </div>
                                    </v-col>
                                    <v-col xs="12" sm="12" md="9" lg="9" xl="9" cols="12"></v-col>
                                    <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
                                        <div class="d-flex" style="justify-content:space-between">
                                            <p style="font-size:16px;">ราคาสินค้าไม่รวมภาษี</p>
                                            <p style="font-size:16px;">{{ formatPrice((parseFloat(total) * (100 / 107))) }}</p>
                                        </div>
                                    </v-col>
                                    <v-col xs="12" sm="12" md="9" lg="9" xl="9" cols="12"></v-col>
                                    <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
                                        <div class="d-flex" style="justify-content:space-between">
                                            <p style="font-size:16px;">ภาษีมูลค่าเพิ่ม 7%</p>
                                            <p style="font-size:16px;">{{ formatPrice(vat) }}</p>
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-divider></v-divider>
                                    </v-col>
                                    <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12"></v-col>
                                    <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                                        <div class="d-flex" style="justify-content:space-between">
                                            <h3>จำนวนเงินทั้งสิ้นรวมภาษี</h3>
                                            <h3>{{ formatPrice(net) }}</h3>
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-divider></v-divider>
                                    </v-col>
                                </v-row>
                                <v-row v-else>
                                    <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12"></v-col>
                                    <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                                        <div class="d-flex" style="justify-content:space-between">
                                            <h3>รวม</h3>
                                            <h3>{{ formatPrice(total) }}</h3>
                                        </div>
                                    </v-col>
                                    <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12"></v-col>
                                    <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                                        <v-row>
                                            <v-col cols="6">
                                                <p style="font-size:16px;">ส่วนลดท้ายบิล</p>
                                            </v-col>
                                            <v-col @input="sumTotal()" cols="6"><v-text-field type="number" v-model="discount"
                                                    color="#D6BFAF" style="width: 50%;float: right;"
                                                     @paste="isPaste($event)"
                                                    single-line outlined dense></v-text-field></v-col>
                                            <v-col cols="12"> <v-divider></v-divider></v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12"></v-col>
                                    <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                                        <div class="d-flex" style="justify-content:space-between">
                                            <h3>ราคาสินค้าไม่รวมภาษี</h3>
                                            <h3>{{ formatPrice(total_dis) }}</h3>
                                        </div>
                                    </v-col>
                                    <v-col v-if="vat !=null" xs="12" sm="12" md="8" lg="8" xl="8" cols="12"></v-col>
                                    <v-col v-if="vat !=null" xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                                        <div class="d-flex" style="justify-content:space-between">
                                            <h3>ภาษีมูลค่าเพิ่ม 7%</h3>
                                            <h3>{{ formatPrice(vat) }}</h3>
                                        </div>
                                    </v-col>
                                    <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12"></v-col>
                                    <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                                        <div class="d-flex" style="justify-content:space-between">
                                            <h3>จำนวนเงินทั้งสิ้นรวมภาษี</h3>
                                            <h3>{{ formatPrice(net) }}</h3>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <div class="title_page ma-3" style="justify-content:center;">
                                        <v-btn type="submit" class="btn_add_data_submit" elevation="4" large>บันทึก</v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-form>
                    </div>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
import { isTelephone, taxNumber, validateEmail, onPaste, minDate, formatPrice } from "@/js/handler";
import { HTTP_ARIN } from "@/axios_arin";
import Swal from "sweetalert2";
export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Pos_inventory_list",
    data() {
        return {
            loading_page: false,
            search: '',
            tab_id: null,
            inventory_remove: false,
            price_new: false,
            ref: true,
            menu_date: false,
            menu_date_exp: false,
            date_exp: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateEN: '',
            dateEXP: '',
            start_date: this.min_date(),
            minDate: new Date().toISOString().substr(0, 10),
            receiptDateMin: '1900-01-01',
            footer_Props: {
                'items-per-page-text': 'รายการต่อหน้า'
            },
            sub_menu: [
                {
                    text: 'คลังสินค้า',
                    disabled: false,
                },
                {
                    text: 'ระบบ POS',
                    disabled: false,
                },
                {
                    text: 'คลังสินค้า',
                    disabled: false,
                },
                {
                    text: 'เพิ่มสินค้าเข้าคลัง',
                    disabled: false,
                    href: '#',
                },
            ],
            headers: [
                {
                    text: 'รหัสสินค้า',
                    value: '',
                    fixed: true,
                },
                {
                    text: 'ชื่อสินค้า',
                    value: '',
                    fixed: true,
                },
                {
                    text: 'จำนวน',
                    value: '',
                    fixed: true,
                },
                {
                    text: 'หน่วยนับ',
                    value: 'product_code',
                    fixed: true,
                },
                {
                    text: 'จัดการ',
                    value: '',
                    fixed: true,
                    sortable: false,
                },
            ],
            reference: [
                { id: 1, reference_name: 'PO-220420220001' },
                { id: 2, reference_name: 'PO-220420220002' },
                { id: 3, reference_name: 'PO-220420220003' },
                { id: 4, reference_name: 'PO-220420220004' },
                { id: 5, reference_name: 'PO-220420220005' },
            ],
            unit_list: [],
            data_list: [],
            product_list: [],
            product: [],
            product_data: [],
            supplier_list: [],
            order_list: [],
            order_data: [],
            order_data_update: [],

            //ตัวแปร
            reference_no: null,
            receipt_no: null,
            vat_type: 0,
            receipt_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            is_credit: null,
            product_id: null,
            unit_id: null,
            supplier_id: null,
            discount: 0,
            total: 0,
            total_dis: 0,
            vat: 0,
            net: 0,
            order: {},
            order_id: null,
            data: {},
            storeDetail:null,
        }
    },
    computed: {
        dateRangeText() {
            return this.dates.join(' ~ ')
        },
    },
    methods: {
        formatPrice(number){
            return formatPrice(number)
        },
        link(link) {
            window.location.href = link;
        },
        inventory_remove_dialog() {
            this.inventory_remove = true;
        },
        price_new_dialog() {
            this.price_new = true;
        },
        getShow_api() {
            let store_id = this.$store.state.store_arin.user_data.store_id;
            // let emp_type = this.$store.state.store_arin.status_permission;
            const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
            HTTP_ARIN.get('/stores/detail/' + store_id, config).then((res) => {
                if (res.data.successful === true) {
                this.storeDetail = res.data.storeDetail;
                this.loading_page = false;
                }
            })
        },
        tabs(number) {
            this.tab_id = number
            if (number === 1) {
                this.data_list = [
                    {
                        id: 1,
                        promotion_code: 'ANB0015',
                        promotion_name: 'inj.GLUCOSE 20 CC for *INJection* 10.-',
                        qty: '49',
                        unit_name: 'Ampule',
                    },
                    {
                        id: 2,
                        promotion_code: 'BER3029',
                        promotion_name: 'tab.CARATEN 12.5 MG.BX 100 s 1300.-',
                        qty: '49',
                        unit_name: 'แผง',
                    },
                    {
                        id: 3,
                        promotion_code: 'PRO-007',
                        promotion_name: 'wt.น้ำกลั่นปราศจากเชื้อ ANB 1000 ML. **ฝาฟ้า 55.-',
                        qty: '20',
                        unit_name: 'ขวด',
                    },
                    {
                        id: 4,
                        promotion_code: 'PRO-008',
                        promotion_name: 'ยาดม IZE JELLI BALM 7 G 29.-',
                        qty: '30',
                        unit_name: 'ขวด',
                    },
                    {
                        id: 5,
                        promotion_code: '2M1205',
                        promotion_name: 'cr.SUPIROCIN OINT 5G 95.-',
                        qty: '5',
                        unit_name: 'หลอด',
                    },
                ]
            } else if (number === 2) {
                this.data_list = [
                    {
                        id: 1,
                        promotion_code: 'BB0004',
                        promotion_name: 'Bananaboat Aloe Vera Gel 90 ml 152.-',
                        qty: '49',
                        unit_name: 'หลอด',
                        status: true,
                    },
                ]
            }
        },
        isNumber: function (evt, number) {
            return isTelephone(evt, number)
        },
        isTaxNumber: function (evt, number) {
            return taxNumber(evt, number)
        },
        isEmail: function (evt) {
            return validateEmail(evt)
        },
        isPaste: function (evt) {
            return onPaste(evt)
        },
        min_date: function () {
            return minDate()
        },
        async selectDate() {
            this.$refs.menu_date.save(this.date)
            this.menu_date = false
        },
        DateEXP_TH(value, i) {
            alert(i);
            const diff = value.split('-')
            const day = diff[2]
            const month = diff[1]
            const year = parseFloat(diff[0]) + 543
            const final_date = day + '/' + month + '/' + year
            this.product_data[i].date_exp = final_date
            return this.product[i].date_exp = final_date
        },
        diffDateTH(value) {
            const diff = value.split('-')
            const day = diff[2]
            const month = diff[1]
            const year = parseFloat(diff[0]) + 543
            const final_date = day + '/' + month + '/' + year
            return this.date = final_date
        },
        diffDateEN() {
            const diff = this.date.split('-')
            const year = parseFloat(diff[2]) - 543
            const month = diff[1]
            const day = diff[0]
            return year + '-' + month + '-' + day
        },
        clearTotal() {
            this.total = 0;
            this.vat = 0;
            this.net = 0;
            this.discount = 0;
            this.order_id = null;
            this.order_data = [];
            this.order = {};
            this.order.vat_type = null;
        },
        getSupplier() {
            const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
            HTTP_ARIN.get('/pos/get/supplier', config).then((res) => {
                if (res.data.successful === true) {
                    this.supplier_list = res.data.supplier_list;
                }
                this.loading_page = false;
            })
        },
        getProducts() {
            const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
            HTTP_ARIN.get('/pos/get/product', config).then((res) => {
                if (res.data.successful === true) {
                    this.product_list = res.data.product;
                }
                this.loading_page = false;
            })
        },
       async getUnit_list() {
            // เคลียร์หน่วยนับทุกครั้งที่เปลี่ยนสินค้า ให้ต้องเลือกหน่วยนับใหม่เสมอ (แม้สินค้าใหม่จะมีหน่วยชื่อเดียวกัน เช่น ขวด)
            this.unit_list = []
            this.unit_id = null
            if (!this.product_id) return
            const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
           await HTTP_ARIN.get('/pos/get/productlist/' + this.product_id, config).then((res) => {
                if (res.data.successful === true) {
                    this.unit_list = res.data.product;
                }
                this.loading_page = false;
            })
        },
        getOrder() {
            const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
            HTTP_ARIN.get('/pos/import/get/order', config).then((res) => {
                if (res.data.successful === true) {
                    this.order_list = res.data.order;
                }
                this.loading_page = false;
            })
        },
        getOrderDetail() {
            const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
            HTTP_ARIN.get('/pos/import/get/order/' + this.order_id, config).then((res) => {
                if (res.data.successful === true) {
                    this.order_data = res.data.data.order_list;
                    this.order = res.data.data.order;
                    this.order.vat_type = 0;
                    for (let i = 0; i < this.order_data.length; i++) {
                        this.order_data_update.push({
                            id: this.order_data[i].id,
                            product_id: this.order_data[i].product_id,
                            product_code: this.order_data[i].product_code,
                            lot_no: this.order_data[i].lot_no,
                            date_expired: this.order_data[i].date_expired,
                            unit_id: this.order_data[i].unit_id,
                            quantity: parseFloat(this.order_data[i].quantity),
                            cost: this.order_data[i].price_per_unit,
                            price: this.order_data[i].total
                        })
                    }
                    this.vat = res.data.data.order.total - (res.data.data.order.total * 100 / 107);
                    this.total = res.data.data.order.total;
                    this.net = parseFloat(this.total);
                }
                this.loading_page = false;
            })
        },
       async addProduct() {
            // ใช้ == เพื่อให้ id เปรียบเทียบได้ทั้ง string และ number (จาก autocomplete/item-value)
            let product_check = this.product_list && this.product_list.find(o => o.id == this.product_id);
            let unit_check = this.unit_list && this.unit_list.find(o => o.unit_id == this.unit_id);
            let product = this.product.find(o => o.unit_id == this.unit_id && o.id == this.product_id);
            if (!product_check || !unit_check) {
                Swal.fire({
                    icon: 'warning',
                    title: 'ข้อมูลไม่ครบ',
                    text: 'กรุณาเลือกสินค้าก่อน แล้วจึงเลือกหน่วยนับ (หรือรอโหลดหน่วยนับเสร็จก่อนเลือก)'
                });
                return;
            }
            if (product == null) {
                this.product.push({
                    id: product_check.id,
                    name: product_check.name,
                    unit_id: unit_check.unit_id,
                    unit: unit_check.unit_name,
                    quantity_in_unit: unit_check.quantity_in_unit,
                    product_code: unit_check.product_code,
                    total_price: 0,
                    qty: null,
                    price: null,
                    discount_amount: '',
                    discount_percent: '',
                    index: this.product.length,
                    lot_no: null,
                    date_exp: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
                    dateEXP: '',
                })
                this.product_data.push({
                    id: product_check.id,
                    name: product_check.name,
                    unit_id: unit_check.unit_id,
                    unit: unit_check.unit_name,
                    quantity_in_unit: unit_check.quantity_in_unit,
                    product_code: unit_check.product_code,
                    total_price: 0,
                    qty: null,
                    price: null,
                    discount_amount: '',
                    discount_percent: '',
                    index: this.product.length,
                    lot_no: null,
                    date_exp: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
                    dateEXP: '',
                })
            }
            // เคลียร์ช่องสินค้าและหน่วยนับหลังเลือกหน่วยนับ เพื่อให้เลือกคู่สินค้า-หน่วยถัดไปได้เลย
            this.product_id = null
            this.unit_id = null
            this.unit_list = []
        },
        deleteProduct(i) {
            this.product.splice(i, 1);
            this.product_data.splice(i, 1);
            let total = 0;
            this.total = 0;
            for (let a = 0; a < this.product.length; a++) {
                            this.total += parseFloat(this.product[a].total_price);
                            total += parseFloat(this.product[a].total_price);
                        }
                        switch(this.vat_type){
                            case 0 : 
                                //  total += parseFloat(this.product[i].total_price);
                                //  this.total = total
                                this.total_dis = ((this.total  - this.discount) * (100/107));
                                this.vat = (total - this.discount) - ((total - this.discount) * (100/107));
                                this.net = this.total_dis + this.vat;
                            break;
                             case 1 : 
                                //  total += parseFloat(this.product[i].total_price);
                                //  this.total = total
                                this.total_dis = (this.total - this.discount);
                                this.vat = this.total_dis * (7 / 100);
                                this.net = this.total_dis + this.vat;
                            break;
                             case 2 : 
                                //  total += parseFloat(this.product[i].total_price);
                                //  this.total = total
                                this.total_dis = (this.total - this.discount);
                                this.vat = null;
                                this.net = this.total_dis;
                            break;
                             case 3 : 
                                //  total += parseFloat(this.product[i].total_price);
                                //  this.total = total
                                this.total_dis = (this.total - this.discount);
                                this.vat = 0;
                                this.net = this.total_dis;
                            break;
                        }
        },

        sumTotal(i = null) {
             let total = 0;
            if (this.ref != true) {
                if (i != null) {
                    if (this.product[i].price != null && this.product[i].qty != null) {
                        this.total = 0;
                        this.product[i].total_price = parseFloat(this.product[i].price == '' || this.product[i].price == null ? 0 : this.product[i].price) * parseFloat(this.product[i].qty == '' || this.product[i].qty == null ? 0 : this.product[i].qty)
                        const lineBase = parseFloat(this.product[i].price == '' || this.product[i].price == null ? 0 : this.product[i].price) * parseFloat(this.product[i].qty == '' || this.product[i].qty == null ? 0 : this.product[i].qty)
                        const lineDiscountAmount = parseFloat(this.product[i].discount_amount == '' || this.product[i].discount_amount == null ? 0 : this.product[i].discount_amount)
                        const lineDiscountPercent = parseFloat(this.product[i].discount_percent == '' || this.product[i].discount_percent == null ? 0 : this.product[i].discount_percent)
                        const linePercentAmount = lineBase * (lineDiscountPercent / 100)
                        this.product[i].total_price = Math.max(lineBase - linePercentAmount - lineDiscountAmount, 0)
                        this.product_data[i].qty = this.product[i].qty
                        this.product_data[i].price = this.product[i].price
                        this.product_data[i].discount_amount = this.product[i].discount_amount
                        this.product_data[i].discount_percent = this.product[i].discount_percent
                        this.product_data[i].lot_no = this.product[i].lot_no
                         this.product_data[i].date_exp = this.product[i].date_exp
                        this.product_data[i].total_price = this.product[i].total_price
                        for (let a = 0; a < this.product.length; a++) {
                            this.total += parseFloat(this.product[a].total_price);
                            total += parseFloat(this.product[a].total_price);
                        }
                        switch(this.vat_type){
                            case 0 : 
                                //  total += parseFloat(this.product[i].total_price);
                                //  this.total = total
                                this.total_dis = ((this.total  - this.discount) * (100/107));
                                this.vat = (total - this.discount) - ((total - this.discount) * (100/107));
                                this.net = this.total_dis + this.vat;
                            break;
                             case 1 : 
                                //  total += parseFloat(this.product[i].total_price);
                                //  this.total = total
                                this.total_dis = (this.total - this.discount);
                                this.vat = this.total_dis * (7 / 100);
                                this.net = this.total_dis + this.vat;
                            break;
                             case 2 : 
                                //  total += parseFloat(this.product[i].total_price);
                                //  this.total = total
                                this.total_dis = (this.total - this.discount);
                                this.vat = null;
                                this.net = this.total_dis;
                            break;
                             case 3 : 
                                //  total += parseFloat(this.product[i].total_price);
                                //  this.total = total
                                this.total_dis = (this.total - this.discount);
                                this.vat = 0;
                                this.net = this.total_dis;
                            break;
                        }
                    }
                } else {
                      this.total = 0;
                for (let i = 0; i < this.product.length; i++) {
                    switch(this.vat_type){
                            case 0 : 
                                 total += parseFloat(this.product[i].total_price);
                                 this.total = total
                                this.total_dis = ((this.total  - this.discount) * (100/107));
                                this.vat = (total - this.discount) - ((total - this.discount) * (100/107));
                                this.net = this.total_dis + this.vat;
                            break;
                            case 1 : 
                                 total += parseFloat(this.product[i].total_price);
                                 this.total = total
                                this.total_dis = (this.total - this.discount);
                                this.vat = this.total_dis * (7 / 100);
                                this.net = this.total_dis + this.vat;
                            break;
                            case 2 : 
                                 total += parseFloat(this.product[i].total_price);
                                 this.total = total
                                this.total_dis = (this.total - this.discount);
                                this.vat = null;
                                this.net = this.total_dis;
                            break;
                            case 3 : 
                                 total += parseFloat(this.product[i].total_price);
                                 this.total = total
                                this.total_dis = (this.total - this.discount);
                                this.vat = 0;
                                this.net = this.total_dis;
                            break;
                        }
                }
                }
            } else {
                this.total = 0;
                for (let i = 0; i < this.order_data.length; i++) {
                    switch(this.vat_type){
                            case 0 : 
                                 total += parseFloat(this.order_data[i].total_price);
                                 this.total = total
                                 this.total_dis = ((this.total  - this.discount) * (100/107));
                                this.vat = (total - this.discount) - ((total - this.discount) * (100/107));
                                this.net = this.total_dis + this.vat;
                            break;
                            case 1 : 
                                 total += parseFloat(this.order_data[i].total_price);
                                 this.total = total
                                this.total_dis = (this.total - this.discount);
                                this.vat = this.total_dis * (7 / 100);
                                this.net = this.total_dis + this.vat;
                            break;
                        }
                }
            }

        },
        saveProduct() {
            if(this.receipt_no == null){
                this.receipt_no = ''
            }
           if(this.$refs.setting.validate()){
                 if (this.ref == true) {
                let duplicateIndices = [];
                let check_product = this.order_data;

                check_product.forEach((element, index) => {
                    // Find the index of the first occurrence of the current element
                    const firstIndex = check_product.findIndex((e, i) => i !== index && e.product_id === element.product_id);
                    // If a duplicate is found
                    if (firstIndex !== -1) {
                        // Add both the current index and the first occurrence index to the duplicateIndices array
                        duplicateIndices.push(index);
                    }
                });
                if (duplicateIndices.length !== 0) {
                    for (let i = 0; i < duplicateIndices.length; i++) {
                        let index = duplicateIndices[i];
                        for (let a = 0; a < this.order_data_update.length; a++) {
                            if (a != index) {
                                if (this.order_data_update[a].product_id == this.order_data_update[index].product_id) {
                                    this.order_data_update[index].quantity = (parseFloat(this.order_data_update[a].quantity) * parseFloat(this.order_data_update[a].price_per_unit)) + (parseFloat(this.order_data_update[index].quantity) * parseFloat(this.order_data_update[index].price_per_unit));
                                    duplicateIndices.splice(index, 1);
                                    this.order_data_update.splice(a, 1);
                                    i = 0;
                                }
                            }
                        }
                    }
                    let order_data = [];
                    let order_data_update = [];
                    for (let i = 0; i < this.order_data.length; i++) {
                        order_data.push({
                            id: this.order_data[i].id,
                            product_id: this.order_data[i].product_id,
                            product_code: this.order_data[i].product_code,
                            lot_no: this.order_data[i].lot_no,
                            date_expired: this.order_data[i].date_expired,
                            unit_id: this.order_data[i].unit_id,
                            quantity: parseFloat(this.order_data[i].quantity),
                            cost: this.order_data[i].price_per_unit,
                            price: this.order_data[i].total,
                            discount_amount: 0,
                            discount_percent: 0
                        })
                    }
                    for (let i = 0; i < this.order_data_update.length; i++) {
                        order_data_update.push({
                            product_id: this.order_data_update[i].product_id,
                            product_code: this.order_data_update[i].product_code,
                            quantity: parseFloat(this.order_data_update[i].quantity)
                        })
                    }
                    let data = {
                        order_id: this.order.id,
                        receipt_no: this.order.pr_code,
                        order_code: null,
                        supplier_id: null,
                        receipt_date: this.order.date,
                        vat_type: 0,
                        discount: 0,
                        total: this.net,
                        import_type: 1,
                        is_credit: this.is_credit,
                        product_list: order_data,
                        product_list_update: order_data_update
                    }
                    this.createimport(data);
                } else {
                    let order_data = [];
                    let order_data_update = [];
                    for (let i = 0; i < this.order_data.length; i++) {
                        order_data.push({
                            id: this.order_data[i].id,
                            product_id: this.order_data[i].product_id,
                            product_code: this.order_data[i].product_code,
                            lot_no: this.order_data[i].lot_no,
                            date_expired: this.order_data[i].date_expired,
                            unit_id: this.order_data[i].unit_id,
                            quantity: parseFloat(this.order_data[i].quantity),
                            cost: this.order_data[i].price_per_unit,
                            price: this.order_data[i].total,
                            discount_amount: 0,
                            discount_percent: 0
                        })
                        order_data_update.push({
                            product_id: this.order_data[i].product_id,
                            product_code: this.order_data[i].product_code,
                            quantity: parseFloat(this.order_data[i].quantity)
                        })
                    }
                    let data = {
                        order_id: this.order.id,
                        receipt_no: this.order.pr_code,
                        order_code: null,
                        supplier_id: null,
                        receipt_date: this.order.date,
                        vat_type: 0,
                        discount: 0,
                        total: this.net,
                        import_type: 1,
                        is_credit: this.is_credit,
                        product_list: order_data,
                        product_list_update: order_data_update
                    }
                    this.createimport(data);
                }
            } else {
               if(this.receipt_no != ''){
                 let duplicateIndices = [];
                let check_product = this.product_data;

                check_product.forEach((element, index) => {
                    // Find the index of the first occurrence of the current element
                    const firstIndex = check_product.findIndex((e, i) => i !== index && e.id === element.id);
                    // If a duplicate is found
                    if (firstIndex !== -1) {
                        // Add both the current index and the first occurrence index to the duplicateIndices array
                        duplicateIndices.push(index);
                    }
                });
                if (duplicateIndices.length !== 0) {
                    for (let i = 0; i < duplicateIndices.length; i++) {
                        let index = duplicateIndices[i];
                        for (let a = 0; a < this.product_data.length; a++) {
                            if (a != index) {
                                if (this.product_data[a].id == this.product_data[index].id) {
                                    this.product_data[index].qty = (parseFloat(this.product_data[a].qty) * parseFloat(this.product_data[a].quantity_in_unit)) + (parseFloat(this.product_data[index].qty) * parseFloat(this.product_data[index].quantity_in_unit));
                                    duplicateIndices.splice(index, 1);
                                    this.product_data.splice(a, 1);
                                    i = 0;
                                }
                            }
                        }
                    }
                    let product = [];
                    let product_data = [];
                    for (let i = 0; i < this.product.length; i++) {
                        product.push({
                            product_id: this.product[i].id,
                            product_code: this.product[i].product_code,
                            lot_no: this.product[i].lot_no,
                            date_expired: this.product[i].date_exp,
                            unit_id: this.product[i].unit_id,
                            quantity: this.product[i].qty,
                            quantity_in_unit: this.product[i].quantity_in_unit,
                            cost: this.product[i].price,
                            price: this.product[i].total_price,
                            discount_amount: this.product[i].discount_amount == null || this.product[i].discount_amount === '' ? 0 : this.product[i].discount_amount,
                            discount_percent: this.product[i].discount_percent == null || this.product[i].discount_percent === '' ? 0 : this.product[i].discount_percent
                        })
                    }
                    for (let i = 0; i < this.product_data.length; i++) {
                        product_data.push({
                            product_code: this.product_data[i].product_code,
                            quantity: this.product_data[i].qty,
                        })
                    }
                    let data = {
                        order_id: null,
                        order_code: this.reference_no == null || this.reference_no == '' ? null : this.reference_no,
                        receipt_no: this.receipt_no,
                        receipt_date: this.receipt_date,
                        supplier_id: this.supplier_id,
                        vat_type: this.vat_type,
                        discount: this.discount == null || this.discount == '' ? 0 : this.discount,
                        total: this.net,
                        import_type: 0,
                        is_credit: 0,
                        product_list: product,
                        product_list_update: product_data
                    }
                    this.createimport(data);
                } else {
                    let product = [];
                    let product_data = [];
                    for (let i = 0; i < this.product_data.length; i++) {
                        product.push({
                            product_id: this.product_data[i].id,
                            product_code: this.product_data[i].product_code,
                            lot_no: this.product_data[i].lot_no,
                            date_expired: this.product_data[i].date_exp,
                            unit_id: this.product_data[i].unit_id,
                            quantity: this.product_data[i].qty,
                            quantity_in_unit: this.product_data[i].quantity_in_unit,
                            cost: this.product_data[i].price,
                            price: this.product_data[i].total_price,
                            discount_amount: this.product_data[i].discount_amount == null || this.product_data[i].discount_amount === '' ? 0 : this.product_data[i].discount_amount,
                            discount_percent: this.product_data[i].discount_percent == null || this.product_data[i].discount_percent === '' ? 0 : this.product_data[i].discount_percent
                        })
                        product_data.push({
                            product_code: this.product_data[i].product_code,
                            quantity: parseFloat(this.product_data[i].qty) * parseFloat(this.product_data[i].quantity_in_unit),
                        })
                    }
                    let data = {
                        order_id: null,
                        order_code: this.reference_no == null || this.reference_no == '' ? null : this.reference_no,
                        receipt_no: this.receipt_no,
                        receipt_date: this.receipt_date,
                        supplier_id: this.supplier_id,
                        vat_type: this.vat_type,
                        discount: this.discount == null || this.discount == '' ? 0 : this.discount,
                        total: this.net,
                        import_type: 0,
                        is_credit: 0,
                        product_list: product,
                        product_list_update: product_data
                    }
                    this.createimport(data);
                }

               }
            }
           }
        },
        createimport(data) {
            const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
            // ส่งไปเพิ่ม
            HTTP_ARIN.post('/pos/import/create', data, config)
                .then((res) => {
                    if (res.data.successful === true) {
                        let timerInterval
                        Swal.fire({
                            title: 'เสร็จสิ้น',
                            text: 'เพิ่มข้อมูลเรียบร้อยแล้ว',
                            icon: 'success',
                            timer: 2000,
                            timerProgressBar: true,
                            didOpen: () => {
                                Swal.showLoading()
                                timerInterval = setInterval(() => { }, 100)
                            },
                            willClose: () => {
                                clearInterval(timerInterval)
                                setTimeout(function () {
                                    window.location.href = '/arin/pos/historyimportinventory';
                                });
                            }
                        })
                    } else {
                        const detail = res.data.error || res.data.message || ''
                        Swal.fire({
                            title: 'ไม่สามารถดำเนินการได้',
                            html: detail ? `กรุณาลองใหม่อีกครั้ง<br><br><small class="text-left">${detail}</small>` : 'กรุณาลองใหม่อีกครั้ง!',
                            icon: 'error',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: `ตกลง`,
                            denyButtonText: `ยกเลิก`,
                        })
                    }
                })
                .catch((err) => {
                    const data = err.response && err.response.data
                    const detail = (data && (data.error || data.message)) || err.message || 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์'
                    Swal.fire({
                        title: 'เกิดข้อผิดพลาด',
                        html: `<span style="text-align:left;white-space:pre-wrap;">${detail}</span>`,
                        icon: 'error',
                        confirmButtonText: 'ตกลง',
                        width: 560,
                    })
                })
        }
    },
    mounted() {
        this.getShow_api()
        this.tabs(1)
        this.getProducts();
        this.getSupplier();
        this.getOrder();

    }
}
</script>

<style scoped>
.input-radius {
    border-radius: 10px;
}

.v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 4px !important;
}</style>
